import moment from "moment";

// Egasi L-bugi (2026-08-31): sana TIMEZONE'siz ketganda backend uni UTC deb
// +5 soat surib yuborardi — haftalik filtr BUGUNGI (ayniqsa tungi) yozuvlarni
// tashlab qo'yardi (jonlida isbotlandi: +05:00 bilan 2 qator, siz 0).
// Endi DOIM ofset bilan yuboriladi — barcha bo'limlar filtrlari bir joyda tuzaldi.
export default function getDateInterval(
  start: any,
  finish: any,
  withTimezone = true
) {
  const begin = start ? toIsoString(moment(start).startOf("day").toDate(), withTimezone) : "";
  const end = start ? toIsoString(moment(finish).endOf("day").toDate(), withTimezone) : "";

  return { begin, end };
}

function toIsoString(date: Date, withTimezone = true) {
  var tzo = -date.getTimezoneOffset(),
    // 2026-09-11 (audit A66, JONLI DALIL — perf/qa/audit/z4): belgi 2021 yildan beri QATTIQ «-» edi, 2026-08-31 da ofset
    // doimiy yoqilgach Toshkent (UTC+5) uchun «-05:00» ketdi — filtr davri 10 soatga surildi (10.09 «Продажи»: 255 qator, 88 tasi
    // boshqa kunniki; to'g'risi 177). Belgi endi haqiqiy ofsetdan olinadi: UTC+5 → «+05:00».
    dif = tzo >= 0 ? "+" : "-",
    pad = function (num: number) {
      var norm = Math.floor(Math.abs(num));
      return (norm < 10 ? "0" : "") + norm;
    };

  return (
    date.getFullYear() +
    "-" +
    pad(date.getMonth() + 1) +
    "-" +
    pad(date.getDate()) +
    "T" +
    pad(date.getHours()) +
    ":" +
    pad(date.getMinutes()) +
    ":" +
    pad(date.getSeconds()) +
    (withTimezone ? dif + pad(tzo / 60) + ":" + pad(tzo % 60) : "")
  );
}
